import type { EGalleryAttachment } from '@common/enums';
import { type EGalleryTypes, type EHorizontalPosition } from '@common/enums';
import { type SelectedFileExtended } from '@common/types/file.type';

export type GalleryOptions = GridOptions | CarouselOptions | CollageOptions;
export type GalleryTypes = EGalleryTypes.carousel | EGalleryTypes.collage | EGalleryTypes.grid;

export type GalleryWidgetData = {
    type: GalleryTypes;
    options: GalleryOptions;
    images: SelectedFileExtended[];
    horizontalAlign: EHorizontalPosition;
    maxWidth: number;
    minHeight?: number;
    resizedHeight?: number;
    hideOnMobile?: boolean;
    hideOnTablet?: boolean;
    hideOnDesktop?: boolean;
    isSynchronizeStyle?: boolean;
    position: {
        width?: number;

        x?: number;
        y?: number;
        rotate?: number;
        zIndex?: number;

        mobileX?: number;
        mobileY?: number;
        mobileRotate?: number;
        mobileZIndex?: number;
    };
};

type BaseOptions = {
    imageGap: number;
    imageGapMobile?: number;
    imageGapTablet?: number;
    borderRadius: number;
    clickable: boolean;
    previewAttachment?: EGalleryAttachment;
    attachment: EGalleryAttachment;
    backgroundColor?: string;
};

export type GridOptions = BaseOptions & {
    // name: string;
    // controlColor?: string; // to decide
    rowItems: number;
    rowItemsMobile?: number;
    rowItemsTablet?: number;
};

export type CarouselOptions = BaseOptions & {
    type: CarouselType;
    rowItems: number;
    rowItemsMobile?: number;
    rowItemsTablet?: number;
    autoplay: boolean;
    knobsColor: string;
    dotsColor: string;
    arrowSize?: number;
    arrowSizeMobile?: number;
    arrowSizeTablet?: number;
    isOutsideContainerArrow?: boolean;
    previewImageHeight?: number;
    previewImageHeightMobile?: number;
    previewImageHeightTablet?: number;
    isShowLastPreviewEdge?: boolean;
};

export type CollageOptions = BaseOptions & {
    style: CollageType;
};

export const CarouselTypes = ['default', 'thumbs-gallery'] as const;

export const CollageTypes = [
    '2col-1',
    '2col-2',
    '2col-3item-1',
    '2col-3item-2',
    '2col-2row',
    '2row-3item',
    '5col-2row',
    'masonry',
    '3col-1',
    '3col-2',
] as const;

export type CarouselType = (typeof CarouselTypes)[number];
export type CollageType = (typeof CollageTypes)[number];
